import './level_type_quote.css';

export * from 'client/common/components/level/_type/level_type_quote';
